import { NgModule } from '@angular/core';
import { RmaBaseUrlPipe } from './rma-base-url.pipe';

@NgModule({
  declarations: [RmaBaseUrlPipe],
  exports: [RmaBaseUrlPipe],
  imports: [],
  providers: [RmaBaseUrlPipe],
})
export class RmaBaseUrlPipeModule {}
